import styled from "@emotion/styled";
import { AdminIcon } from "../../assets/icons/icons";
import { MemberDetail } from "../../types/types";
import SelectBox, { menuItemType } from "../selectBox";
import useGetUserGroup from "../../hooks/useGetUserGroup";
import theme from "../../theme";
import { useWindowSize } from "@reactuses/core";
import { Label } from "../common/Label";
import { TextInput } from "../common/TextInput";
import { useI18n } from "../../locales";

const { sm, md, lg } = theme.screen;

const InputField: React.FC<{ data?: MemberDetail }> = (props) => {
  const { data } = props;
  const { width } = useWindowSize();
  const { t } = useI18n();
  const { data: GroupOptions } = useGetUserGroup({});
  const userGroupType: menuItemType[] = [];
  if (GroupOptions) {
    for (let i = 0; i < GroupOptions.length; i++) {
      userGroupType.push({
        value: GroupOptions[i].group_id,
        title: GroupOptions[i].name,
      });
    }
  }
  // console.log("디테일 모달 데이터", data);
  return (
    <UserInfoWrapper>
      <ImageWrapper>
        {data?.admin_image ? (
          <CustomImg
            src={`${process.env.REACT_APP_BASE_URL}/${data?.admin_image}`}
            alt="사용자 이미지"
          />
        ) : (
          <AdminIcon width={167} height={167} />
        )}
      </ImageWrapper>

      <UserInfo>
        {/* screen sm ~ lg */}
        {width < lg && (
          <>
            <RowWrapper>
              <InputWrapper>
                <Label text={t.manageUser.userId} htmlFor="id" />
                <TextInput
                  disabled
                  value={data?.id ?? ""}
                  id="id"
                  name="id"
                  width={"100%"}
                  readOnly
                />
              </InputWrapper>
              <InputWrapper>
                <Label text={t.login.password} htmlFor="pw" />
                <TextInput
                  disabled
                  defaultValue="****"
                  id="pw"
                  name="pw"
                  width={"100%"}
                />
              </InputWrapper>
              <InputWrapper>
                <Label text={t.manageUser.passwordConfirm} htmlFor="pwCheck" />
                <TextInput
                  disabled
                  defaultValue="****"
                  id="pwCheck"
                  name="pwCheck"
                  width={"100%"}
                />
              </InputWrapper>
            </RowWrapper>
            <RowWrapper>
              <InputWrapper>
                <Label text={t.manageUser.email} htmlFor="email" />
                <TextInput
                  disabled
                  value={data?.email ?? ""}
                  id="email"
                  name="email"
                  width={"100%"}
                  readOnly
                />
              </InputWrapper>
              <InputWrapper>
                <Label text={t.manageUser.contact} htmlFor="phone" />
                <TextInput
                  disabled
                  value={data?.phone ?? ""}
                  id="phone"
                  name="phone"
                  width={"100%"}
                  readOnly
                />
              </InputWrapper>
            </RowWrapper>
            <RowWrapper>
              <InputWrapper>
                {/* <Label text="담당기관" htmlFor="group_id" /> */}
                <Label text={t.manageUser.area} htmlFor="group_id" />
                <SelectBox
                  disabled
                  filter={data?.gov_id || "00000"}
                  menuItems={userGroupType}
                  width={"100%"}
                  srLabel={t.manageUser.area}
                />
              </InputWrapper>
              <InputWrapper>
                <Label text={t.manageUser.accountName} htmlFor="name" />
                <TextInput
                  disabled
                  value={data?.name ?? ""}
                  id="name"
                  name="name"
                  width={"100%"}
                  readOnly
                />
              </InputWrapper>
            </RowWrapper>
            <RowWrapper>
              <InputWrapper>
                <Label text={t.manageUser.address} htmlFor="address" />
                <TextInput
                  disabled
                  value={data?.address ?? ""}
                  id="address"
                  name="address"
                  width={"100%"}
                  readOnly
                />
              </InputWrapper>
              <InputWrapper>
                <Label text={t.manageUser.detailAddress} htmlFor="address_detail" />
                <TextInput
                  disabled
                  value={data?.address_detail ?? ""}
                  id="address_detail"
                  name="address_detail"
                  width={"100%"}
                  readOnly
                />
              </InputWrapper>
            </RowWrapper>
          </>
        )}

        {/* screen lg ~ */}
        {width >= lg && (
          <>
            <FirstRow>
              <InputWrapper>
                <Label text={t.manageUser.userId} htmlFor="id" />
                <TextInput
                  disabled
                  value={data?.id ?? ""}
                  id="id"
                  name="id"
                  width={"230px"}
                  readOnly
                />
              </InputWrapper>
              <InputWrapper>
                <Label text={t.login.password} htmlFor="pw" />
                <TextInput
                  disabled
                  defaultValue="****"
                  id="pw"
                  name="pw"
                  width={"230px"}
                />
              </InputWrapper>
              <InputWrapper>
                <Label text={t.manageUser.passwordConfirm} htmlFor="pwCheck" />
                <TextInput
                  disabled
                  defaultValue="****"
                  id="pwCheck"
                  name="pwCheck"
                  width={"230px"}
                />
              </InputWrapper>
            </FirstRow>
            <SecondRow>
              <InputWrapper>
                <Label text={t.manageUser.email} htmlFor="email" />
                <TextInput
                  disabled
                  value={data?.email ?? ""}
                  id="email"
                  name="email"
                  width={"230px"}
                  readOnly
                />
              </InputWrapper>
              <InputWrapper>
                <Label text={t.manageUser.contact} htmlFor="phone" />
                <TextInput
                  disabled
                  value={data?.phone ?? ""}
                  id="phone"
                  name="phone"
                  width={"230px"}
                  readOnly
                />
              </InputWrapper>
              <InputWrapper>
                {/* <Label text="담당기관" htmlFor="group_id" /> */}
                <Label text={t.manageUser.area} htmlFor="group_id" />
                <SelectBox
                  disabled
                  filter={data?.gov_id || "00000"}
                  menuItems={userGroupType}
                  width={230}
                  mr="0px"
                  srLabel={t.manageUser.area}
                />
              </InputWrapper>
            </SecondRow>
            <ThirdRow>
              <InputWrapper>
                <Label text={t.manageUser.accountName} htmlFor="name" />
                <TextInput
                  disabled
                  value={data?.name ?? ""}
                  id="name"
                  name="name"
                  width={"230px"}
                  readOnly
                />
              </InputWrapper>
              <InputWrapper>
                <Label text={t.manageUser.address} htmlFor="address" />
                <TextInput
                  disabled
                  value={data?.address ?? ""}
                  id="address"
                  name="address"
                  width={"230px"}
                  readOnly
                />
              </InputWrapper>

              <InputWrapper>
                <Label text={t.manageUser.detailAddress} htmlFor="address_detail" />
                <TextInput
                  disabled
                  value={data?.address_detail ?? ""}
                  id="address_detail"
                  name="address_detail"
                  width={"230px"}
                  readOnly
                />
              </InputWrapper>
            </ThirdRow>
          </>
        )}
      </UserInfo>
    </UserInfoWrapper>
  );
};

const UserInfoWrapper = styled.div`
  background: ${theme.color.neutral_50};
  border-radius: 10px;
  padding-left: 40px;
  padding-right: 30px;
  padding-top: 30px;
  padding-bottom: 30px;
  width: 100%;
  display: flex;
  gap: 44px;
  margin-bottom: 40px;

  @media (max-width: ${sm}px) {
    padding: 10px;
  }

  @media (max-width: ${lg}px) {
    flex-direction: column;
    align-items: center;
  }
`;

const UserInfo = styled.div`
  width: 100%;
`;

const FirstRow = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 26px;

  @media (max-width: ${lg}px) {
    display: none;
  }
`;

const SecondRow = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 26px;

  @media (max-width: ${lg}px) {
    display: none;
  }
`;

const ThirdRow = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;

  @media (max-width: ${lg}px) {
    display: none;
  }
`;

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media (max-width: ${sm}px) {
    width: 100%;
  }
  @media (min-width: ${sm + 1}px) and (max-width: ${md}px) {
    width: 100%;
  }

  @media (min-width: ${md + 1}px) and (max-width: ${lg}px) {
    /* width: 50%; */
    width: 100%;
  }
`;

const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 400px;
  display: flex;
  border-radius: 15px;
  align-items: center;
  justify-content: center;
  background: ${theme.color.neutral_50};

  @media (min-width: ${lg + 1}px) {
    width: 167px;
    height: 250px;
  }
`;

const CustomImg = styled.img`
  width: 100%;
  object-fit: contain;

  @media (min-width: ${lg + 1}px) {
    width: 167px;
    height: 250px;
  }
`;

const RowWrapper = styled.div`
  width: 100%;
  gap: 30px;
  margin-bottom: 30px;
  flex-direction: column;
  display: none;

  @media (min-width: ${md + 1}px) and (max-width: ${lg}px) {
    /* flex-direction: row; */
  }

  @media (max-width: ${lg}px) {
    display: flex;
  }
`;
export default InputField;
